var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"size":"lg","title":"Add a Member","hide-footer":"","id":"clientModal"}},[_c('div',{staticClass:"modal-body",staticStyle:{"width":"100%"}},[_c('clientCreateClientForm',{attrs:{"edit":false}}),_c('div',{staticClass:"d-flex justify-content-between mt-2"},[_c('div')])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }